import orderBy from 'lodash/fp/orderBy';
import { converge, map, multiply, pipe, prop, sum, filter, head, propOr, reduce, omit, add } from 'ramda';
import moment from 'moment-timezone';
import flow from 'lodash/flow';
import {
  countTotalCostWithoutTaxes,
  countCostWithTaxes,
} from '../common/helpers/appointments';
import config from '../../config';

export const mapCostToPrice = items => items.map(item => ({
  ...item,
  price: item.cost,
  priceWithoutTaxes: item.costWithoutTaxes,
  priceWithTaxes: item.costWithTaxes,
}));

const getPriceWithoutTaxes = appointment => ({
  ...appointment,
  priceWithoutTaxes: countTotalCostWithoutTaxes(appointment.appointment_service) - (appointment.promoAmount || 0),
  priceWithTaxes: countCostWithTaxes(appointment.appointment_service) - (appointment.promoAmount || 0),
});

export const cleanupAppointment = omit([
  'barber',
]);

export const mapAppointment = appointment => flow([
  cleanupAppointment,
  getPriceWithoutTaxes,
  item => ({
    ...item,
    name: `${item.description} @ ${moment.tz(item.start, item.timezone).format(config.dateTimeFormat)}`,
  }),
])(appointment);

const multiplyQuantityWithPrice = converge(multiply, [prop('priceWithoutTaxes'), prop('quantity')]);
const multiplyQuantityWithPriceWithTax = converge(multiply, [
  converge(add, [prop('priceWithoutTaxes'), prop('taxBeforeAdjustments')]),
  prop('quantity'),
]);
export const sumPrices = pipe(
  map(multiplyQuantityWithPrice),
  sum,
);

export const sumPricesForTip = pipe(
  map(multiplyQuantityWithPriceWithTax),
  sum
);

const getTransactions = propOr([], 'transactions');
const filterTopUpTransactions = filter(item => item.action === 'add');
const getTransactionsTotalAmount = reduce((memo, item) => memo + item.amount, 0);

export const getTopUpAmount = pipe(getTransactions, filterTopUpTransactions, getTransactionsTotalAmount);
export const getLastTopUp = pipe(getTransactions, filterTopUpTransactions, orderBy(['createdAt'], ['desc']), head);
